<p>{{ 'Response.LOG01' | translate}}</p>
<button id="close-button" type="button" mat-stroked-button color="primary" [mat-dialog-close]
        cdkFocusInitial>{{ 'Multilang.close' | translate }}</button>
